import config from "../../config";
import Sidebar from "../../components/partials/Sidebar";
import Header from "../../components/partials/Header";
import Breadcrumb from "../../components/Breadcrumb";
import { useEffect, useState } from "react";
import Pagination from "../../components/Pagination";
import Swal from "sweetalert2";
import { apiListSyncLog, apiResendSyncLog } from "../../api/master";
import moment from "moment";
import Tippy from "@tippyjs/react";
import "tippy.js/dist/tippy.css";
import filter from "../../images/icons/filter.png";
import resendIcon from "../../images/icons/resend.png";
import { FaShare } from "react-icons/fa";
import "../Sale/style.css";
import "./style.css";

function SyncLogList() {
  const [user, setUser] = useState({});
  const [comp, setComp] = useState({});

  const [list, setList] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [userCount, setUserCount] = useState(10);
  const [moduleNameFilter, setModuleNameFilter] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [filtersVisible, setFiltersVisible] = useState(false);

  const [selectedIds, setSelectedIds] = useState([]);
  const [isBatchProcessing, setIsBatchProcessing] = useState(false);
  const [batchProgress, setBatchProgress] = useState({ current: 0, total: 0 });
  const [processingId, setProcessingId] = useState(null);

  useEffect(() => {
    if (localStorage.getItem("inventory")) {
      const invData = JSON.parse(localStorage.getItem("inventory"));
      setUser(invData?.userData || {});
      setComp(invData?.userData?.comp_data || {});
    }
  }, []);

  const fetchList = async (
    modFilter = moduleNameFilter,
    stFilter = statusFilter,
    pageNum = currentPage,
  ) => {
    setIsLoading(true);
    try {
      const branch_id = JSON.parse(localStorage.getItem("inventory"))?.userData?.branch_data?.[0]?.branch_id;
      const response = await apiListSyncLog({
        paginate: 1,
        page_no: pageNum - 1,
        branch_id: branch_id,
        page_size: userCount,
        module: modFilter ? modFilter : undefined,
        module_name: modFilter ? modFilter : undefined,
        status: stFilter !== "all" ? stFilter : undefined,
      });

      if (response?.data?.data?.list) {
        setList(response.data.data.list);
        const totalCount = response?.data?.data?.count || 0;
        const computedTotalPages =
          response?.data?.data?.totalPage ||
          Math.ceil(totalCount / Number(userCount)) ||
          1;
        setTotalPage(computedTotalPages);
      } else {
        setList([]);
        setTotalPage(1);
      }
    } catch (err) {
      setList([]);
      setTotalPage(1);
      const errMsg =
        err?.response?.data?.data?.message ||
        err?.response?.data?.message ||
        err?.message ||
        "Failed to fetch sync logs";
      Swal.fire({
        icon: "error",
        title: "Error",
        text: errMsg,
      });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchList(moduleNameFilter, statusFilter, currentPage);
  }, [currentPage, userCount]);

  const handleSearchChange = (e) => {
    setModuleNameFilter(e.target.value);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    setCurrentPage(1);
    fetchList(moduleNameFilter, statusFilter, 1);
  };

  const handleClearFilters = () => {
    setModuleNameFilter("");
    setStatusFilter("all");
    setCurrentPage(1);
    fetchList("", "all", 1);
  };

  const handleSelectAll = (e) => {
    if (e.target.checked) {
      const allIds = list.map((item) => item.id);
      setSelectedIds(allIds);
    } else {
      setSelectedIds([]);
    }
  };

  const handleSelectRow = (id) => {
    if (selectedIds.includes(id)) {
      setSelectedIds(selectedIds.filter((item) => item !== id));
    } else {
      setSelectedIds([...selectedIds, id]);
    }
  };

  const handleResendSingle = async (row) => {
    setProcessingId(row.id);
    try {
      await apiResendSyncLog({ id: row.id });
      Swal.fire({
        icon: "success",
        title: "Resent Successfully",
        text: `Sync request for ${row.module || row.module_name || "item"} (${row.ref_no || row.module_ref || row.id}) has been sent.`,
        timer: 2000,
        showConfirmButton: false,
      });
      await fetchList();
    } catch (err) {
      const errMsg =
        err?.response?.data?.data?.message ||
        err?.response?.data?.message ||
        err?.message ||
        "Failed to resend sync log";
      Swal.fire({
        icon: "error",
        title: "Resend Failed",
        text: errMsg,
      });
    } finally {
      setProcessingId(null);
    }
  };

  const handleResendSelected = async () => {
    if (selectedIds.length === 0) {
      Swal.fire("", "Please select at least one log to resend.");
      return;
    }

    const confirmRes = await Swal.fire({
      title: "Resend Selected Logs?",
      text: `Are you sure you want to resend ${selectedIds.length} selected items?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, Resend All",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#3734FE",
    });

    if (!confirmRes.isConfirmed) return;

    setIsBatchProcessing(true);
    setBatchProgress({ current: 0, total: selectedIds.length });

    Swal.fire({
      title: "Resending Sync Logs...",
      html: `Processing <b id="swal-batch-progress">0 / ${selectedIds.length}</b> sync logs`,
      allowOutsideClick: false,
      allowEscapeKey: false,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
      },
    });

    let successCount = 0;
    let failCount = 0;
    let lastErrorMsg = "";
    const idsToProcess = [...selectedIds];

    for (let i = 0; i < idsToProcess.length; i++) {
      const id = idsToProcess[i];
      setBatchProgress({ current: i + 1, total: idsToProcess.length });
      const bElem = document.getElementById("swal-batch-progress");
      if (bElem) {
        bElem.textContent = `${i + 1} / ${idsToProcess.length}`;
      }
      try {
        await apiResendSyncLog({ id });
        successCount++;
      } catch (err) {
        failCount++;
        lastErrorMsg =
          err?.response?.data?.data?.message ||
          err?.response?.data?.message ||
          err?.message ||
          "Failed";
      }
      await new Promise((resolve) => setTimeout(resolve, 300));
    }

    setIsBatchProcessing(false);
    setSelectedIds([]);
    await fetchList();

    if (failCount === 0) {
      Swal.fire({
        icon: "success",
        title: "Batch Resend Complete",
        text: `Successfully processed all ${successCount} items.`,
      });
    } else {
      Swal.fire({
        icon: "error",
        title: "Batch Resend Finished with Errors",
        text: `Success: ${successCount}, Failed: ${failCount}.${lastErrorMsg ? ` Error: ${lastErrorMsg}` : ""}`,
      });
    }
  };

  const getStatusBadge = (status) => {
    if (!status) return <span className="badge bg-secondary px-2 py-1">-</span>;
    const s = String(status).toUpperCase();
    let bgClass = "bg-secondary";
    if (s === "SUCCESS" || s === "SYNC" || s === "SYNCED") {
      bgClass = "bg-success";
    } else if (s === "FAILED" || s === "FAIL" || s === "ERROR") {
      bgClass = "bg-danger";
    } else if (s === "PENDING") {
      bgClass = "bg-info text-dark";
    } else if (s === "PROCESSING") {
      bgClass = "bg-warning text-dark";
    } else if (s === "NEW") {
      bgClass = "bg-primary";
    }
    return <span className={`badge ${bgClass} px-2 py-1`}>{status}</span>;
  };

  const isAllSelected =
    list.length > 0 &&
    list.every((item) => selectedIds.includes(item.id));

  return (
    <>
      <div className="d-flex min-vh-100" style={{ background: "#DAE5FF" }}>
        <Sidebar />
        <div className="content m-1 p-2">
          <Header />

          <main className="bg-white rounded-4" id="sale">
            <div className="container-fluid p-2">
              {/* Header Controls Matching Challan Page */}
              <div className="row align-items-center">
                <div className="col">
                  <Breadcrumb path={["Sync Log"]} />
                </div>
                <div className="col text-end d-flex align-items-center justify-content-end">
                  <Tippy content="Filter">
                    <img
                      onClick={() => setFiltersVisible(!filtersVisible)}
                      src={filter}
                      className="img-fluid me-3"
                      role="button"
                      style={{ width: "2rem" }}
                      alt="Filter"
                    />
                  </Tippy>
                  <span className="me-3">
                    <label className="me-1">Per Page</label>
                    <select
                      value={userCount}
                      onChange={(e) => setUserCount(e.target.value)}
                      className="custom-select"
                      style={{ height: "32px" }}
                    >
                      <option value="10">10</option>
                      <option value="25">25</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </span>
                  <button
                    className="btn btn-primary px-4 py-2"
                    style={{
                      height: "33px",
                      display: "inline-flex",
                      justifyContent: "center",
                      alignItems: "center",
                      backgroundColor: selectedIds.length > 0 ? "#3734FE" : "#94a3b8",
                      borderRadius: "8px",
                      fontWeight: "600",
                      fontSize: "14px",
                      border: "none",
                    }}
                    disabled={selectedIds.length === 0 || isBatchProcessing}
                    onClick={handleResendSelected}
                  >
                    {isBatchProcessing ? (
                      <>
                        <span className="spinner-border spinner-border-sm me-1"></span>
                        Resending ({batchProgress.current}/{batchProgress.total})...
                      </>
                    ) : (
                      <>Resend Selected ({selectedIds.length})</>
                    )}
                  </button>
                </div>
              </div>

              {/* Filter Drawer Section */}
              {filtersVisible && (
                <form onSubmit={handleSearchSubmit} id="saleAdd" className="my-3" autoComplete="off">
                  <div className="row g-3 mb-2 align-items-end">
                    <div className="col-md-4">
                      <label htmlFor="module_name_filter">Module Name</label>
                      <input
                        type="text"
                        id="module_name_filter"
                        className="form-control"
                        placeholder="Enter module name..."
                        value={moduleNameFilter}
                        onChange={(e) => setModuleNameFilter(e.target.value)}
                      />
                    </div>
                    <div className="col-md-4">
                      <label htmlFor="status_filter">Status</label>
                      <select
                        id="status_filter"
                        className="form-select"
                        value={statusFilter}
                        onChange={(e) => setStatusFilter(e.target.value)}
                      >
                        <option value="all">All Status</option>
                        <option value="NEW">NEW</option>
                        <option value="PENDING">PENDING</option>
                        <option value="SYNCED">SYNCED</option>
                      </select>
                    </div>
                    <div className="col-md-4 d-flex gap-2">
                      <button
                        type="submit"
                        className="btn btn-primary px-4"
                        style={{
                          background: "#4263eb",
                          borderRadius: "8px",
                          fontWeight: "600",
                          fontSize: "14px",
                          height: "35px",
                        }}
                      >
                        Apply Filter
                      </button>
                      <button
                        type="button"
                        className="btn btn-secondary px-4"
                        onClick={handleClearFilters}
                        style={{
                          background: "#767196",
                          borderRadius: "8px",
                          fontWeight: "600",
                          fontSize: "14px",
                          height: "35px",
                        }}
                      >
                        Clear
                      </button>
                    </div>
                  </div>
                </form>
              )}

              {/* Main Table Section matching Challan layout */}
              <div className="row mb-4">
                <div className="col table-responsive-lg">
                  <table className="table mt-4 rounded">
                    <thead>
                      <tr>
                        <th style={{ width: "40px" }} className="text-center">
                          <input
                            type="checkbox"
                            checked={isAllSelected}
                            onChange={handleSelectAll}
                          />
                        </th>
                        <th style={{ width: "60px" }}>Sr. No.</th>
                        <th>Module Name</th>
                        <th>Module Reference</th>
                        <th>Error Message</th>
                        <th className="text-center">Attempts</th>
                        <th>Status</th>
                        <th>Created At</th>
                        <th className="text-center" style={{ width: "100px" }}>
                          Actions
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {isLoading ? (
                        <tr>
                          <td colSpan="9" className="text-center py-4">
                            <span className="spinner-border spinner-border-sm me-2 text-primary"></span>
                            Loading Sync Logs...
                          </td>
                        </tr>
                      ) : list.length === 0 ? (
                        <tr>
                          <td colSpan="9" className="text-center py-4 text-muted">
                            No sync logs found.
                          </td>
                        </tr>
                      ) : (
                        list.map((row, index) => {
                          const isChecked = selectedIds.includes(row.id);
                          const displayErrMsg = row.err_msg || row.error_message;
                          const attemptsVal =
                            row.attempts !== undefined && row.attempts !== null
                              ? row.attempts
                              : row.attempt !== undefined && row.attempt !== null
                              ? row.attempt
                              : 0;

                          return (
                            <tr
                              key={row.id || index}
                              style={isChecked ? { backgroundColor: "#cff4fc" } : {}}
                            >
                              <td className="text-center">
                                <input
                                  type="checkbox"
                                  checked={isChecked}
                                  onChange={() => handleSelectRow(row.id)}
                                />
                              </td>
                              <td>{(currentPage - 1) * userCount + index + 1}</td>
                              <td className="fw-semibold text-dark">
                                {row.module || row.module_name || "-"}
                              </td>
                              <td>
                                <span className="bg-light text-dark px-2 py-1 rounded fw-semibold" style={{ fontSize: "14px" }}>
                                  {row.ref_no || row.module_ref || "N/A"}
                                </span>
                              </td>
                              <td>
                                {displayErrMsg ? (
                                  <span className="text-danger small font-monospace">
                                    ⚠ {displayErrMsg}
                                  </span>
                                ) : (
                                  <span className="text-muted small">-</span>
                                )}
                              </td>
                              <td className="text-center fw-semibold">
                                <span className="badge bg-light text-dark border px-2 py-1">
                                  {attemptsVal}
                                </span>
                              </td>
                              <td>{getStatusBadge(row.status)}</td>
                              <td className="small text-muted">
                                {row.created_at || row.createdAt
                                  ? moment(row.created_at || row.createdAt).format("DD-MM-YY hh:mm A")
                                  : "N/A"}
                              </td>
                              <td className="text-center">
                                <Tippy content="Resend Sync">
                                  {processingId === row.id ? (
                                    <span className="spinner-border spinner-border-sm text-primary"></span>
                                  ) : (
                                    <FaShare
                                      size={18}
                                      className="resend-action-icon"
                                      role="button"
                                      alt="Resend"
                                      style={{
                                        color: "var(--theme-btn-color, #4263eb)",
                                        cursor: "pointer",
                                        verticalAlign: "middle",
                                      }}
                                      onClick={() => handleResendSingle(row)}
                                    />
                                  )}
                                </Tippy>
                              </td>
                            </tr>
                          );
                        })
                      )}
                    </tbody>
                  </table>
                </div>
              </div>

              {/* Footer Pagination matching Challan page */}
              <div className="row">
                <div className="col">
                  <Pagination
                    nPages={Math.max(1, totalPage || 1)}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                  />
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </>
  );
}

export default SyncLogList;
